export const GET_PERSONA_QRCODE = 'GET_PERSONA_QRCODE';

/**
 * Get persona QRCode.
 * @function getPersonaQRCode
 * @returns {Object} Get persona QRCode results action.
 */
export function getPersonaQRCode(path) {
  return {
    type: GET_PERSONA_QRCODE,
    path,
    request: {
      op: 'get',
      path: `${path}/@getQrcode`,
    },
  };
}
